export default "__VITE_ASSET___vdHwQyj__"